// extracted by mini-css-extract-plugin
export default {"settings":"style_settings__usfcJ","settings__checkbox":"style_settings__checkbox__vYJlE","render":"style_render__zT2gC"};